<div [hidden]="!loading" class="loading">{{'Loading' | translate}}&#8230;</div>

<div class="options_side" *ngIf="moduleUrl">
  <div class="logo_area">
    <img src="../../../assets/images/rwanda_logo_name.svg" alt="">
  </div>
  <ul class="notif_tab_menu">
    <li class="nav-item" [ngClass]="{'active': sidebarActiveTab === 1}">
      <a class="nav-link" id="one-tab" data-toggle="tab" href="javascript:void(0)" (click)="changeTab(1)">{{'What’s New in Atlas' | translate}}</a>
    </li>
    <li class="nav-item " [ngClass]="{'active': sidebarActiveTab === 2}">
      <a class="nav-link" id="two-tab" data-toggle="tab" href="javascript:void(0)" (click)="changeTab(2)">{{'Notifications' | translate}}
        <span class="count">6</span></a>
    </li>
  </ul>

  <div class="tab-content">
    <div class="tab_pane fade show active" id="news" *ngIf="sidebarActiveTab === 1">
      <div class="news_update">
        <div class="single_news">
          <h5 class="date_posted">June 11 2020</h5>
          <h4 class="news_title">The new X1000B</h4>
          <div class="news_excerpt">
            <img src="../../../assets/images/x1000B.png" class="inline_img" alt="">
            <p>The revolutionary d.light X-series solar home system grows with your aspirations...</p>
          </div>
          <a href="javascript:void(0)" class="learn_more">
            <span>{{'Learn More' | translate}}</span>
            <svg class="sr_heading_title_icon">
              <use xlink:href="#open-menu"></use>
            </svg>
          </a>
        </div>
        <div class="single_news">
          <h5 class="date_posted">June 11 2020</h5>
          <h4 class="news_title">Atlas Version 4.0.1 Changes</h4>
          <div class="news_excerpt">
            <ul>
              <li>Updated API to resolve three compile errors #326</li>
              <li>Added Customer support page #303</li>
              <li>Fixed menu animation bug on product page #329</li>
            </ul>
          </div>
          <a href="javascript:void(0)" class="learn_more">
            <span>{{'Learn More' | translate}}</span>
            <svg class="sr_heading_title_icon">
              <use xlink:href="#open-menu"></use>
            </svg>
          </a>
        </div>
        <div class="single_news">
          <h5 class="date_posted">June 11 2020</h5>
          <h4 class="news_title">New Calls Modules</h4>
          <div class="news_excerpt">
            <p>I was Loading a token and then moved to another phone it is now saying that the token is incompatible
              however it is already completely up to date.</p>
          </div>
          <a href="javascript:void(0)" class="learn_more">
            <span>{{'Learn More' | translate}}</span>
            <svg class="sr_heading_title_icon">
              <use xlink:href="#open-menu"></use>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="tab_pane fade show active" id="notice" *ngIf="sidebarActiveTab === 2">
      <div class="tasks_section">
        <h3 class="section_title">{{'Escalation' | translate}}</h3>
        <ul class="escalation_list">
          <li>
            <a href="javascript:void(0)" class="dropdown_menu_item">
              <span class="dropdown_menu_item_icon">
                <img src="../../../assets/images/crm.svg" alt="">
              </span>
              <span class="dropdown_menu_item_label">CRM Tasks <span class="count">2</span></span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" class="dropdown_menu_item">
              <span class="dropdown_menu_item_icon">
                <img src="../../../assets/images/inventory.svg" alt="">
              </span>
              <span class="dropdown_menu_item_label">Inventory Tasks <span class="count">3</span></span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" class="dropdown_menu_item">
              <span class="dropdown_menu_item_icon">
                <img src="../../../assets/images/escalate_icon.svg" alt="">
              </span>
              <span class="dropdown_menu_item_label">Shipments <span class="count">1</span></span>
            </a>
          </li>
        </ul>
      </div>
      <div class="tasks_section">
        <h3 class="section_title">Tasks</h3>
        <div class="single_news">
          <h5 class="date_posted">June 11 2020</h5>
          <div class="news_excerpt">
            <p>
              I was Loading a token and then moved to another phone it is now saying that the token is incompatible
              however it is already completely up to date.
            </p>
          </div>
          <a href="javascript:void(0)" class="learn_more">
            <span>Open Task</span>
            <svg class="sr_heading_title_icon">
              <use xlink:href="#open-menu"></use>
            </svg>
          </a>
        </div>
        <div class="single_news">
          <h5 class="date_posted">June 11 2020</h5>
          <div class="news_excerpt">
            <p>
              I was Loading a token and then moved to another phone it is now saying that the token is incompatible
              however it is already completely up to date.
            </p>
          </div>
          <a href="javascript:void(0)" class="learn_more">
            <span>Open Task</span>
            <svg class="sr_heading_title_icon">
              <use xlink:href="#open-menu"></use>
            </svg>
          </a>
        </div>
        <div class="single_news">
          <h5 class="date_posted">June 11 2020</h5>
          <div class="news_excerpt">
            <p>
              I was Loading a token and then moved to another phone it is now saying that the token is gone.
            </p>
          </div>
          <a href="javascript:void(0)" class="learn_more">
            <span>Open Task</span>
            <svg class="sr_heading_title_icon">
              <use xlink:href="#open-menu"></use>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="profile_switcher" [ngClass]="{'is-open': isOpen}" *ngIf="!moduleUrl">
  <div class="switcher_toggle">
    <svg class="item_svg_icon cog_icon" (click)="profileSwitcher()">
      <use xlink:href="#cog_icon"></use>
    </svg>
    <span class="user_name" (click)="home()">{{tenantName | slice:0:20}}</span>
    <svg class="item_svg_icon" (click)="countrySwitcher()">
      <use xlink:href="#expand"></use>
    </svg>
  </div>

  <div class="sidebar_header">
    <div class="partner_switcher" [ngClass]="{'open': isCountryOpen}">
      <ul class="partner_list">
        <!-- <li class="input">
          <input type="text" placeholder="Type a partner name" />
        </li> -->
        <li *ngFor='let tenant of tenants'>
          <span class="flag">
            {{ tenant.countryFlag }}
          </span>
          <span class="text">
            <a class="link" href="javascript:void(0)" (click)="switchTenant(tenant)">
              {{tenant.name}}
            </a>
          </span>
        </li>
     </ul>
    </div>
  </div>

  <div class="profile_switcher__panel">
    <div class="panel__header">
      <span class="user_avatar">
        <img src="../../../assets/images/rwanda_logo.svg" alt="">
      </span>
      <span class="user_name">{{tenantName | slice:0:20}}</span>
      <span class="close_profiler" (click)="profileSwitcher()"></span>
    </div>
    <!--<div class="panel_section">-->
    <!--<ul class="panel_nav">-->
    <!--<li>-->
    <!--<a href="javascript:void(0)">-->
    <!--<svg class="panel_nav_icon">-->
    <!--<use xlink:href="#cog_icon"></use>-->
    <!--</svg>-->
    <!--<span class="panel_nav_label">Manage Settings</span>-->
    <!--</a>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->

    <div class="panel_section">
      <div class="text_exclude">{{'You are signed in as' | translate}} <strong>{{ user }}</strong></div>
      <ul class="panel_nav">
        <li>
          <a href="javascript:void(0)">
            <svg class="panel_nav_icon">
              <use xlink:href="#cog_icon"></use>
            </svg>
            <span class="panel_nav_label" (click)="redirectTo('/identity-management/users/profile/settings')">{{'Manage your profile' | translate}}</span>
          </a>
        </li>
        <li *ngIf="have('can-access-global-settings')">
          <a href="javascript:void(0)">
            <svg class="panel_nav_icon">
              <use xlink:href="#cog_icon"></use>
            </svg>
            <span (click)="redirectTo('/global-settings')"
                  class="panel_nav_label">{{'Atlas Settings' | translate}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)">
            <svg class="panel_nav_icon">
              <use xlink:href="#cog_icon"></use>
            </svg>
            <span class="panel_nav_label" [routerLink]="['/login']" (click)="logout()">{{'Sign Out' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="panel_section other_nav">
      <ul class="panel_nav">
        <li><a href="/terms-and-conditions">{{'Terms' | translate}}</a></li>
        <li><a href="/privacy-policy">{{'Privacy' | translate}}</a></li>
        <li><a href="/faq">{{'FAQ' | translate}}</a></li>
        <li class="pull-right">
          <select #langSelect (change)="changeLang(langSelect.value);profileSwitcher()">
            <option *ngFor="let lang of translate.getLangs()" [value]="lang"
              [selected]="lang === translate.currentLang">{{ lang }}</option>
          </select>
        </li>
      </ul>
    </div>

  </div>


</div>


<div class="app_primary_nav" *ngIf="!moduleUrl">
  <ul class="nav_menu" *ngIf="menu$ | async as menuItems">

    <ng-container
      *ngTemplateOutlet="Recursion; context:{ list: menuItems, level: 0}"
    ></ng-container>

    <ng-template #Recursion let-list="list" let-level="level">
      <ng-container *ngFor="let menuItem of list; let i = index">
        <li class="menu_item" *ngIf="have(menuItem.permission) && isFeatureEnabled(menuItem)"
            [ngClass]="{'menu_item_expandable': haveSubMenu(menuItem), 'open': i === expandedMenu}">

          <a href="javascript:void(0)" [routerLink]="[menuItem.path]" routerLinkActive="router-link-active"
             class="menu_item_link" [style.margin-left]="10 * level + 'px'"
             *ngIf="!haveSubMenu(menuItem) && canViewSideBarMenu(menuItem)">
            <svg class="item_svg_icon" (click)="onClick(menuItem.path)">
              <use [attr.xlink:href]="'#'+menuItem.icon"></use>
            </svg>
            <span class="menu_item">{{ menuItem.title | translate }}</span>
          </a>

          <a href="javascript:void(0)" (click)="level === 0 ? clickExpanded(i) : null"
             data-toggle="dropdown" class="menu_item_link" [style.margin-left]="10 * level + 'px'"
             *ngIf="haveSubMenu(menuItem)">
            <svg class="item_svg_icon" (click)="onClick(menuItem.path)">
              <use [attr.xlink:href]="'#'+menuItem.icon"></use>
            </svg>
            <span class="menu_item_label" (click)="onClick(menuItem.path)">{{ menuItem.title | translate }}</span>
            <svg class="menu_item_caret">
              <use xlink:href="#expand"></use>
            </svg>
          </a>

          <div class="menu_item_expandable_content" *ngIf="haveSubMenu(menuItem)">
            <ul class="menu_nested">
              <ng-container
                *ngTemplateOutlet="Recursion; context:{ list: menuItem.subMenu, level: level + 1 }"
              ></ng-container>
            </ul>
          </div>
        </li>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="routerUrl$ | async as routerUrl">
      <ng-container *ngIf="routerUrl.toString().includes('ticketing')" >
        <li class="menu_item" >
          <a class="menu_item_link nav-dynamic-header-element mt-15px" >

            <span class="menu_item_label" style="font-weight:600">My Issues</span>
          </a>
        </li>
        <hr class="nav-separator"/>
        <li class="menu_item">
          <a class="menu_item_link " (click)="openAssignedTickets()" >
            <svg class="item_svg_icon" width="15" height="15" viewBox="0 0 0.45 0.45" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.225.075a.075.075 0 1 0 0 .15.075.075 0 0 0 0-.15M.113.15a.113.113 0 1 1 .225 0 .113.113 0 0 1-.225 0M.15.338a.056.056 0 0 0-.056.056.019.019 0 1 1-.037 0A.094.094 0 0 1 .15.3H.3a.094.094 0 0 1 .094.094.019.019 0 1 1-.037 0A.056.056 0 0 0 .301.338z" fill="currentColor"/></svg>
            <span class="menu_item_label">Assigned To Me</span>
          </a>
        </li>
        <li class="menu_item">
          <a class="menu_item_link " (click)="openRaisedTickets()" >
            <svg class="item_svg_icon" width="18" height="18" viewBox="0 0 0.337 0.337" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M.153.037a.4.4 0 0 0-.001.082l.001.019a.011.011 0 0 1-.022.003L.129.131A.3.3 0 0 0 .116.078Q.106.048.088.042a.014.014 0 0 0-.015.003.02.02 0 0 0-.004.017q.005.02.014.04l.002.004L.1.144.107.17l.002.007A.011.011 0 0 1 .09.189L.075.174.072.171.063.161Q.053.151.041.149.033.148.03.151.027.153.024.16a.03.03 0 0 0 .003.019l.022.03.015.016.016.017a.14.14 0 0 1 .042.072h.136A.3.3 0 0 1 .276.227L.287.198Q.298.171.309.136C.316.111.314.097.311.089A.02.02 0 0 0 .3.079Q.292.078.291.081L.285.095.281.118v.001L.277.14.273.146.265.149Q.255.147.255.137L.256.11q.002-.024 0-.048v.002Q.253.047.24.044L.23.045.221.057.218.073.216.097.215.119l-.001.02-.001.005a.01.01 0 0 1-.01.006.01.01 0 0 1-.01-.006L.191.136V.107L.189.038Q.186.024.171.024C.156.024.154.029.152.039M.211.033A.04.04 0 0 0 .172 0C.154 0 .135.01.131.034L.129.051a.06.06 0 0 0-.033-.03.04.04 0 0 0-.039.009.04.04 0 0 0-.01.038l.015.043.001.004.011.028A.05.05 0 0 0 .042.128a.04.04 0 0 0-.025.005.04.04 0 0 0-.015.02C-.003.165.001.18.007.19a.2.2 0 0 0 .026.035l.016.017.016.017c.021.022.036.044.036.067a.01.01 0 0 0 .011.011H.27A.01.01 0 0 0 .281.326c0-.038.007-.064.016-.091l.01-.027L.33.143Q.341.102.331.081A.04.04 0 0 0 .304.058a.03.03 0 0 0-.026.005V.061A.044.044 0 0 0 .244.02a.04.04 0 0 0-.027.004L.21.029" fill="currentColor"/></svg>
            <span class="menu_item_label">Raised By Me</span>
          </a>
        </li>
        <li class="menu_item">
          <a class="menu_item_link " (click)="openTaggedInTickets()" >
            <svg class="item_svg_icon" width="18" height="18" fill="currentColor" viewBox="0 0 0.54 0.54" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" transform="rotate(90)"><path d="M.202.09q.045 0 .08.033L.36.202l.112.112-.158.158L.19.348.122.281A.112.112 0 0 1 .202.09m0-.045a.15.15 0 0 0-.111.046Q.046.138.045.202C.044.266.061.284.091.313l.068.068q.003.004.008.006l.117.117q.014.013.032.013C.334.517.339.513.348.504L.506.346a.045.045 0 0 0 0-.064L.394.17.316.091A.16.16 0 0 0 .202.045m0 .124a.034.034 0 1 1 0 .068.034.034 0 0 1 0-.068m0-.022a.056.056 0 0 0-.056.055c0 .031.025.056.056.056S.259.233.259.202A.056.056 0 0 0 .202.146"/></svg>
            <span class="menu_item_label">Tagged In</span>
          </a>
        </li>


        <ng-container *ngIf="teams.length > 0">
          <li class="menu_item" >
            <a class="menu_item_link nav-dynamic-header-element mt-15px" >

              <span class="menu_item_label" style="font-weight:600">My Teams</span>
            </a>
          </li>
          <hr class="nav-separator"/>


          <li class="menu_item " *ngFor="let team of teams">
            <a class="menu_item_link " (click)="openTeam(team.id, team.name)" >
              <svg class="item_svg_icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" xml:space="preserve" width="18" height="18"><path d="M18 12.711a5.2 5.2 0 0 0-.912-2.941 5.25 5.25 0 0 0-1.623-1.533 3.9 3.9 0 0 0 1.226-2.842 3.92 3.92 0 0 0-3.916-3.916c-1.28 0-2.48.633-3.208 1.673a4 4 0 0 0-1.134 0 3.93 3.93 0 0 0-3.208-1.673 3.92 3.92 0 0 0-3.916 3.916c0 1.118.472 2.128 1.226 2.842A5.3 5.3 0 0 0 .912 9.77 5.2 5.2 0 0 0 0 12.711v2.178h3.775v1.631h10.45v-1.63H18zM12.775 2.446c1.626 0 2.95 1.323 2.95 2.95s-1.323 2.95-2.95 2.95l-.087-.001.006-.019a4 4 0 0 0 .126-.439l.007-.032q.013-.06.024-.122l.01-.058a4 4 0 0 0 .026-.187l.011-.098.008-.1.005-.079q.004-.085.004-.171v-.02l-.004-.174-.003-.05-.011-.146-.003-.033a3.9 3.9 0 0 0-2.324-3.178 2.96 2.96 0 0 1 2.205-.992M7.979 4.26l.028-.01a3 3 0 0 1 .206-.065 3 3 0 0 1 .786-.107 3 3 0 0 1 .836.122l.067.021.09.03.027.01a2.96 2.96 0 0 1 1.893 2.308l.004.026q.008.054.014.109l.004.04.008.1.003.043q.003.064.003.13v.016q0 .063-.003.125l-.002.039q-.003.06-.009.12l-.005.046-.01.077-.009.06a3 3 0 0 1-.044.217l-.031.117-.013.046-.021.066-.018.053-.021.059-.039.1-.019.044-.037.082-.004.01-.014.029-.044.087-.018.033-.001.002-.052.09-.021.035q-.029.047-.06.093l-.039.056-.034.047-.077.1-.049.06-.032.037-.053.059-.032.034-.089.09-.054.052-.039.035-.097.083q-.039.032-.08.063l-.022.017c-.491.365-1.099.581-1.756.581s-1.265-.216-1.756-.581l-.022-.016-.08-.063-.033-.027-.064-.056-.039-.035-.055-.052-.089-.09-.032-.034-.053-.06-.032-.036-.081-.101-.045-.06-.034-.048-.039-.056-.06-.093-.021-.035-.053-.091-.018-.034-.045-.087-.015-.031-.002-.005-.039-.085-.018-.041-.04-.102-.02-.056-.02-.058-.02-.063-.027-.095-.017-.067-.012-.053-.014-.065-.018-.103-.008-.056-.011-.083-.005-.041-.009-.123-.002-.036-.003-.133a2 2 0 0 1 .006-.18l.008-.106.004-.037q.006-.057.014-.113l.003-.022a2.96 2.96 0 0 1 1.893-2.31M2.275 5.395a2.954 2.954 0 0 1 2.95-2.95c.849 0 1.65.369 2.205.992a3.9 3.9 0 0 0-2.324 3.18l-.003.029-.012.152-.003.046a4 4 0 0 0-.005.182q0 .093.005.185l.005.074.008.106.01.094a4 4 0 0 0 .026.187l.011.063.032.156a4 4 0 0 0 .122.426l.009.027-.087.001a2.954 2.954 0 0 1-2.95-2.95m2.31 6.161-.031.051-.065.108-.035.061-.09.165-.052.102-.031.064-.05.108-.026.059-.054.131-.016.038-.064.172-.013.04a5 5 0 0 0-.063.196l-.033.114-.018.068-.027.11-.04.182-.013.068-.021.123-.009.058-.024.182v.002l-.016.166H.966v-1.212a4.25 4.25 0 0 1 2.443-3.848 3.9 3.9 0 0 0 1.816.448q.284 0 .568-.042l.09.124.032.041.094.115.04.046a4 4 0 0 0 .141.154l.087.087.033.033q-.063.038-.125.078l-.02.013q-.062.04-.122.082l-.042.029-.107.077-.034.025q-.067.051-.133.104l-.029.024-.143.122-.101.092-.026.024-.121.118-.031.031-.09.094-.035.038-.099.111-.015.018q-.055.065-.109.132l-.029.037-.079.103-.03.04-.1.141-.102.155m.156 3.998v-1.212q0-.08.003-.16l.003-.052.006-.107.006-.064.009-.094.009-.068q.005-.045.012-.088l.012-.07.014-.085.015-.071.017-.082.017-.072.02-.08.02-.072.022-.078.023-.072.025-.076.026-.071.027-.074.028-.07.03-.073.031-.069.032-.071.034-.068.035-.069.036-.067.037-.068.039-.066.039-.066.041-.065.042-.065.043-.063.044-.063.046-.062.046-.061.048-.061.048-.059.05-.059.051-.058.052-.057.053-.056.054-.055.055-.054.056-.053.057-.052.058-.051.059-.05.06-.049q.03-.025.062-.049l.126-.093a4 4 0 0 1 .194-.131l.135-.082a4 4 0 0 1 .211-.116l.069-.035.055-.026a3.9 3.9 0 0 0 1.816.448 3.9 3.9 0 0 0 1.816-.448l.055.026.142.073.138.078.135.082.131.087.064.045.063.046.123.095.061.049.059.05.115.103.057.053.055.054.055.055.052.056.053.057.05.057.05.059.048.059.048.061.046.061.046.062.044.063.044.064.041.064.041.065.039.066a4 4 0 0 1 .112.202l.035.069.034.068.032.071.031.069.03.072.028.071.027.074.026.071.025.076.023.071a2 2 0 0 1 .042.15l.02.08.017.072.017.082.015.071.014.084.012.071.012.088.009.069.009.094.006.064q.004.053.006.107l.003.052q.003.08.003.16v1.212zm9.466-1.631a5 5 0 0 0-.04-.351l-.009-.055-.022-.126-.013-.066-.024-.114a6 6 0 0 0-.062-.247l-.033-.115-.018-.061a4 4 0 0 0-.058-.174l-.064-.172-.015-.037-.055-.132-.026-.058-.05-.109-.031-.063-.086-.166-.056-.101-.035-.06-.065-.108-.031-.05-.102-.155-.1-.141-.03-.04-.08-.104-.029-.037q-.053-.067-.109-.132l-.015-.017a5 5 0 0 0-.225-.245l-.03-.031-.121-.118-.026-.024-.102-.092-.039-.034-.104-.087-.028-.023-.133-.104-.034-.025a5 5 0 0 0-.27-.188l-.021-.014q-.062-.04-.125-.078l.032-.032q.045-.043.088-.088a4 4 0 0 0 .141-.154l.039-.045.095-.117.03-.039.091-.125q.284.042.568.042a3.9 3.9 0 0 0 1.816-.448 4.25 4.25 0 0 1 2.443 3.848v1.212z"/></svg>
              <span class="menu_item_label" style="max-width:150px">{{team.name}}</span>
            </a>
          </li>

        </ng-container>
        <hr class="nav-separator"/>
        <li class="menu_item">
          <a class="menu_item_link " (click)="openNotifications()" >
            <svg class="item_svg_icon" width="18" height="18" viewBox="0 0 0.54 0.54" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M.228.051a.045.045 0 0 1 .084 0C.377.07.427.134.427.225c0 .059.012.092.034.116l.027.026.006.007v.077H.356a.1.1 0 0 1-.04.054.09.09 0 0 1-.094 0Q.188.485.181.451H.045V.374L.051.367.078.342C.101.317.112.284.112.225c0-.092.05-.155.116-.174M.229.45q.005.008.017.016a.04.04 0 0 0 .047 0A.04.04 0 0 0 .309.45zM.45.393.428.372C.398.339.383.295.383.225.383.14.33.09.271.09S.159.14.159.225c0 .07-.016.114-.046.147L.091.393v.013h.36z"/></svg>
            <span class="menu_item_label">Notifications</span>
          </a>
        </li>


      </ng-container>
    </ng-container>

  </ul>
</div>



<div class="app_footer" *ngIf="!moduleUrl">
  <!-- <a href="javascript:void(0)" class="help_btn"><img src="../../../assets/images/help_icon.svg" alt="">Help</a> -->
  <div class="powered_by">{{'Copyright' | translate}} d.light {{currentYear}}  <br /> {{'Build Version' | translate}} {{version}} </div>
</div>
